import createUseStyles from '@picsart/rc/create';
import { canHover, isLeftToRight } from '@picsart/rc/helpers';
import { Transitions } from '@picsart/rc/enums';
import { FontWeights } from '@picsart/rc/fonts';

const useBaseTemplateStyles = createUseStyles(
  {
    root: {},
    buttonWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    button: {
      display: 'block',
      minWidth: 152,
      height: 46,
      padding: [0, 24],
      border: '1px solid var(--backgrounds-tint-5)',
      borderRadius: 8,
      outline: 'none',
      backgroundColor: 'transparent',
      transition: `box-shadow ${Transitions.Default} ease-in-out`,
      cursor: 'pointer',

      [canHover()]: {
        '&:hover': {
          boxShadow: '0px 5px 10px -2px var(--backgrounds-negative)',
        },
      },
      [canHover(false)]: {
        '&:active': {
          boxShadow: '0px 5px 10px -2px var(--backgrounds-negative)',
        },
      },
    },
    buttonInner: {
      display: 'inline-block',
      verticalAlign: 'middle',
      height: 16,
      paddingInlineEnd: 20,
      fontWeight: FontWeights.SemiBold,
      fontSize: 14,
      color: 'var(--accents-primary-base-active)',
      lineHeight: '16px',
      position: 'relative',
    },
    buttonIcon: {
      width: 16,
      height: 16,
      position: 'absolute',
      top: 0,

      [isLeftToRight()]: {
        right: 0,
      },
      [isLeftToRight(false)]: {
        left: 0,
      },

      '& > svg': {
        '& > path': {
          fill: 'var(--accents-primary-base-active)',
        },
      },
    },
  },
  { name: 'top-bar' },
);

export default useBaseTemplateStyles;
